<template>
  <div class="section-header">
    <div class="section-header__top">
      <div class="section-header__title-area">
        <h4 class="section-header__title">{{ title }}</h4>
        <div v-if="subtitle" class="section-header__subtitle">{{ subtitle }}</div>
      </div>
      <div v-if="$slots.actions" class="section-header__actions">
        <slot name="actions" />
      </div>
    </div>
    <slot name="below-title" />
  </div>
</template>

<script setup lang="ts">
interface Props {
  title: string;
  subtitle?: string;
}

defineProps<Props>();
</script>

<style scoped>
.section-header__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.section-header__title {
  font-weight: 600;
  font-size: 15px;
  line-height: 22px;
  font-family: var(--font-brand);
  margin: 0;
}

.section-header__subtitle {
  font-size: 13px;
  color: #475467;
  margin-top: 2px;
}

.section-header__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
</style>
